import { useCallback, useEffect, useReducer, useRef } from "react";
import { createReducer, initializeValidationState } from "./validationState.js";
function useFormValidation(validationClass, options = {}, deps = []) {
    const [validationState, dispatch] = useReducer(createReducer(validationClass, options.validation), initializeValidationState(validationClass, options.values || {}, options.validation, null != options.loadValues));
    const safeDispatch = useRef(dispatch);
    useEffect(()=>{
        safeDispatch.current = dispatch;
        return ()=>{
            safeDispatch.current = null;
        };
    }, [
        dispatch
    ]);
    const loadValues = useCallback(async ()=>{
        if (null != options.loadValues) try {
            safeDispatch.current?.({
                type: 'loadValues'
            });
            const values = await options.loadValues();
            safeDispatch.current?.({
                type: 'loadedValues',
                values: values || {}
            });
        } catch (error) {
            safeDispatch.current?.({
                type: 'loadValuesFailed',
                error: error instanceof Error ? error.message : 'Failed loading values'
            });
        }
        else if (null != options.values) {
            safeDispatch.current?.({
                type: 'loadValues'
            });
            safeDispatch.current?.({
                type: 'loadedValues',
                values: options.values
            });
        }
    }, [
        options
    ]);
    useEffect(()=>{
        loadValues();
    }, deps);
    const setValue = (name, value)=>{
        dispatch({
            type: 'setValue',
            fieldName: name,
            value
        });
    };
    const submit = async ()=>{
        const result = null == options.onSubmit || validationState.hasErrors ? void 0 : options.onSubmit(validationState.values);
        if (null != result) {
            const serverValidationPointers = await result;
            safeDispatch.current?.({
                type: 'submit',
                serverValidationPointers
            });
        } else safeDispatch.current?.({
            type: 'submit'
        });
    };
    const publicValidationState = {
        values: validationState.values,
        disableSubmit: validationState.disableSubmit,
        fields: validationState.fields,
        hasErrors: validationState.hasErrors,
        loadingValues: validationState.loadingValues,
        loadedValues: validationState.loadedValues,
        loadValuesFailed: validationState.loadValuesFailed,
        loadValuesError: validationState.loadValuesError
    };
    const contract = true === validationState.hasErrors ? void 0 : validationState.values;
    return [
        publicValidationState,
        setValue,
        submit,
        contract
    ];
}
export { useFormValidation };
